const plans = [
  {
    handle: 'free',
    version: 1,
    title: 'Free',
    available: true,
    monthlyPrice: 0,
    yearlyPrice: 0,
    yearlyPriceFull: 0,
    transactionFeePercentage: 0,
    benefits: ['Up to $3K sales per month'],
  },
  {
    handle: 'flexible',
    title: 'Starter',
    available: false,
    monthlyPrice: 0,
    yearlyPrice: 0,
    yearlyPriceFull: 0,
    transactionFeePercentage: 4,
    description: 'Legacy plan',
    benefits: ['4% transaction fee'],
  },
  {
    handle: 'premium',
    title: 'Premium',
    available: false,
    monthlyPrice: 2900,
    yearlyPrice: 2900,
    yearlyPriceFull: 29000,
    transactionFeePercentage: 0.5,
    description: 'Legacy plan',
    benefits: ['0.5% transaction fee'],
  },
  {
    handle: 'launch',
    version: 1,
    title: 'Launch',
    available: false,
    monthlyPrice: 2900,
    yearlyPrice: 2400,
    yearlyPriceFull: 29000,
    transactionFeePercentage: 0,
    benefits: ['Up to $3K sales per month'],
  },
  {
    handle: 'launch',
    version: 2,
    title: 'Launch',
    available: false,
    monthlyPrice: 2900,
    yearlyPrice: 1900,
    yearlyPriceFull: 29000,
    transactionFeePercentage: 0,
    benefits: ['Up to $3K sales per month'],
  },
  {
    handle: 'launch',
    version: 3,
    title: 'Launch',
    available: true,
    monthlyPrice: 2900,
    yearlyPrice: 2400,
    yearlyPriceFull: 29000,
    transactionFeePercentage: 0,
    benefits: ['Up to $3K sales per month'],
  },
  {
    handle: 'scale',
    version: 1,
    bracket: 10000,
    title: 'Scale',
    available: false,
    monthlyPrice: 5900,
    yearlyPrice: 4700,
    yearlyPriceFull: 59000,
    transactionFeePercentage: 0,
    benefits: ['Up to $10K sales per month'],
  },
  {
    handle: 'scale',
    version: 2,
    bracket: 10000,
    title: 'Scale',
    available: false,
    monthlyPrice: 7900,
    yearlyPrice: 4900,
    yearlyPriceFull: 79000,
    transactionFeePercentage: 0,
    benefits: ['Up to $10K sales per month'],
  },
  {
    handle: 'scale',
    version: 1,
    title: 'Scale',
    available: false,
    monthlyPrice: 19900,
    yearlyPrice: 15000,
    yearlyPriceFull: 199000,
    transactionFeePercentage: 0,
    benefits: ['Unlimited sales per month'],
  },
  {
    handle: 'scale',
    version: 2,
    title: 'Scale',
    available: false,
    monthlyPrice: 14900,
    yearlyPrice: 9900,
    yearlyPriceFull: 149000,
    transactionFeePercentage: 0,
    benefits: ['Unlimited sales per month'],
  },
  {
    handle: 'scale',
    version: 3,
    title: 'Scale',
    available: true,
    monthlyPrice: 9900,
    yearlyPrice: 8300,
    yearlyPriceFull: 99000,
    transactionFeePercentage: 0,
    benefits: ['Up to $10K sales per month'],
  },
  {
    handle: 'unlimited',
    version: 1,
    title: 'Unlimited',
    available: true,
    monthlyPrice: null,
    yearlyPrice: 83300,
    yearlyPriceFull: 999000,
    transactionFeePercentage: 0,
    benefits: ['Unlimited sales'],
  },
];

function getPlanWithHighestVersion(handle) {
  // Bracketed entries (Grow's old per-bracket pricing, now the Scale v4
  // $10K entry) are historical variants of a base version, addressed only
  // through the explicit (handle, version, bracket) lookup below — never
  // "the current" plan for a bare handle lookup.
  const plansWithHandle = plans.filter(plan => plan.handle === handle && !plan.bracket);

  return plansWithHandle.sort((a, b) => b.version - a.version)[0];
}

function getPlanWithVersion(handle, version, bracket) {
  const candidates = plans.filter(plan => plan.handle === handle && plan.version === version);

  // Grow's v1/v2 prices live on as bracketed Scale entries; sellers without a
  // bracket keep the plain entry of the same version.
  const match = bracket
    ? candidates.find(plan => plan.bracket === bracket)
    : candidates.find(plan => !plan.bracket);

  return match || candidates.find(plan => !plan.bracket);
}

function getPlan(handle, version = null, bracket = null) {
  if (version) {
    const plan = getPlanWithVersion(handle, version, bracket);

    if (plan) {
      return plan;
    }
  }

  return getPlanWithHighestVersion(handle);
}

function getBillingPeriod(billingPeriod) {
  switch (billingPeriod) {
    case 'year':
      return 'yearly';
    case 'month':
      return 'monthly';
    default:
      return 'monthly';
  }
}

export { getPlan, getBillingPeriod };

export default plans;
